export default __webpack_public_path__ + "static/press-release-contentstack-sm-a049467ff9b82ad03f17f4aed54c01aa.jpg";